import React from 'react';
import DesignImporterModal from './components/DesignImporterModal';

export default function DesignImporter({ open, onOpen, onClose, refresh }) {
  return (
    <DesignImporterModal
      open={open}
      onOpen={onOpen}
      onClose={onClose}
      refresh={refresh}
    />
  );
}
